"use client";
/*
 * Documentation:
 * TagScoreTxt — https://app.subframe.com/ae91faa555e6/library?component=TagScoreTxt_9df7c039-044e-4bb8-88c6-e6ca0a81d662
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface TagScoreTxtRootProps extends React.HTMLAttributes<HTMLDivElement> {
  score?: React.ReactNode;
  variant?: "default" | "alert" | "medium" | "success" | "plain";
  className?: string;
}

const TagScoreTxtRoot = React.forwardRef<HTMLElement, TagScoreTxtRootProps>(
  function TagScoreTxtRoot(
    {
      score,
      variant = "default",
      className,
      ...otherProps
    }: TagScoreTxtRootProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "group/9df7c039 flex flex-col items-start gap-2",
          className
        )}
        ref={ref as any}
        {...otherProps}
      >
        {score ? (
          <span
            className={SubframeUtils.twClassNames(
              "text-body font-body text-subtext-color",
              {
                "text-success-700": variant === "success",
                "text-warning-700": variant === "medium",
                "text-error-700": variant === "alert",
              }
            )}
          >
            {score}
          </span>
        ) : null}
      </div>
    );
  }
);

export const TagScoreTxt = TagScoreTxtRoot;
